import React from 'react';
import styled from 'styled-components';

const SErrorLayout = styled.div`
    color: red;
    margin-top: 10px;
    font-size: 12px;
    margin-left: 13px;
`;

const ErrorMessages = ({
    errorMessage = [],
    isOnBlurTriggered
}) => {
    return (
        isOnBlurTriggered &&
            errorMessage.map((item) => {
                return <SErrorLayout key={item}>{item}</SErrorLayout>;
            })
    );
};

export default ErrorMessages;
